import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import Lenis from "lenis";
import { ContentProvider } from "@/lib/api";
import { Nav, Footer } from "@/components/Chrome";
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import RealisationsPage from "@/pages/RealisationsPage";
import ProjectPage from "@/pages/ProjectPage";
import { JournalPage, ArticlePage } from "@/pages/Journal";
import { SimplePage, PlateformePage, NotFound } from "@/pages/SimplePages";
import BriefPage from "@/pages/BriefPage";
import GuideRegiesPage from "@/pages/GuideRegies";
import AdminPage from "@/pages/AdminPage";
import CapturesAdmin from "@/pages/CapturesAdmin";
import AdminCampagnes from "@/pages/AdminCampagnes";
import ClientLogin from "@/pages/client/ClientLogin";
import ClientSetPassword from "@/pages/client/ClientSetPassword";
import ClientForgotPassword from "@/pages/client/ClientForgotPassword";
import ClientDashboard from "@/pages/client/ClientDashboard";
import ClientCampaign from "@/pages/client/ClientCampaign";
import ClientDocuments from "@/pages/client/ClientDocuments";

function ArticleRoute() {
  const { slug } = useParams();
  return <ArticlePage slug={slug} />;
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isClient = location.pathname.startsWith("/espace-client");

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <>
      <ScrollManager />
      {!isAdmin && !isClient && <Nav />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/realisations" element={<RealisationsPage />} />
        <Route path="/realisations/:slug" element={<ProjectPage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/:slug" element={<ArticleRoute />} />
        <Route path="/brief" element={<BriefPage />} />
        {/* Ancienne adresse : redirection, en attendant le 301 côté plateforme. */}
        <Route path="/contact" element={<Navigate to="/brief/" replace />} />
        <Route path="/guide-regies-pme" element={<GuideRegiesPage />} />
        <Route path="/plateforme" element={<PlateformePage />} />
        <Route path="/a-propos" element={<SimplePage slug="a-propos" />} />
        <Route path="/mentions-legales" element={<SimplePage slug="mentions-legales" />} />
        <Route path="/politique-de-confidentialite" element={<SimplePage slug="politique-de-confidentialite" />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/captures" element={<CapturesAdmin />} />
        <Route path="/admin/campagnes" element={<AdminCampagnes />} />
        <Route path="/espace-client" element={<ClientDashboard />} />
        <Route path="/espace-client/campagnes/:id" element={<ClientCampaign />} />
        <Route path="/espace-client/documents" element={<ClientDocuments />} />
        <Route path="/espace-client/connexion" element={<ClientLogin />} />
        <Route path="/espace-client/invitation/:token" element={<ClientSetPassword mode="invite" />} />
        <Route path="/espace-client/mot-de-passe-oublie" element={<ClientForgotPassword />} />
        <Route path="/espace-client/reinitialiser/:token" element={<ClientSetPassword mode="reset" />} />
        <Route path="/:slug" element={<ServicePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && !isClient && <Footer />}
    </>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
